import { render, staticRenderFns } from "./default_msg.vue?vue&type=template&id=525c2078&scoped=true"
import script from "./default_msg.vue?vue&type=script&lang=ts"
export * from "./default_msg.vue?vue&type=script&lang=ts"
import style0 from "./default_msg.vue?vue&type=style&index=0&id=525c2078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c2078",
  null
  
)

export default component.exports